import { useReducer, useState } from "react";
import styles from "./styles.module.scss";
import { tabsLabels, tabsComponents } from "./config";
import { Tabs } from "../Tabs";
import { LaunchDate } from "../LaunchDate";
import { ProductLaunchProps } from "./types";

const initialState = {
  showRecomendations: false,
  showCategories: false,
  showDetails: false,
};

type Action =
  | { type: "SET_RECOMMENDATIONS"; payload: boolean }
  | { type: "SET_CATEGORIES"; payload: boolean }
  | { type: "SET_DETAILS"; payload: boolean };

const reducer = (state: typeof initialState, action: Action) => {
  switch (action.type) {
    case "SET_RECOMMENDATIONS":
      return { ...state, showRecomendations: action.payload };
    case "SET_CATEGORIES":
      return { ...state, showCategories: action.payload };
    case "SET_DETAILS":
      return { ...state, showDetails: action.payload };
    default:
      return state;
  }
};

export const Details = ({ activeIndex, setActiveIndex }) => {
  const [launchDate, setLaunchDate] = useState<number | null>(0);
  const [state, dispatch] = useReducer(reducer, initialState);

  const ActiveComponent = tabsComponents[activeIndex];

  const showLaunchDate =
    activeIndex !== 0 || (activeIndex === 0 && state.showDetails);

  const productLaunchProps: ProductLaunchProps = {
    showRecomendations: state.showRecomendations,
    setShowRecomendations: (value: boolean) =>
      dispatch({ type: "SET_RECOMMENDATIONS", payload: value }),
    showCategories: state.showCategories,
    setShowCategories: (value: boolean) =>
      dispatch({ type: "SET_CATEGORIES", payload: value }),
    showDetails: state.showDetails,
    setShowDetails: (value: boolean) =>
      dispatch({ type: "SET_DETAILS", payload: value }),
  };

  return (
    <div className={styles.wrapper}>
      {showLaunchDate && (
        <LaunchDate launchDate={launchDate} setLaunchDate={setLaunchDate} />
      )}
      <div className={styles.detailsWrapper}>
        <Tabs
          tab={activeIndex}
          setTab={setActiveIndex}
          tabsLabels={tabsLabels}
        />
        <ActiveComponent {...(activeIndex === 0 ? productLaunchProps : {})} />
      </div>
    </div>
  );
};
